import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <path
        d="M15.182 19.955C15.4749 20.2479 15.9498 20.2479 16.2427 19.955C16.5356 19.6621 16.5356 19.1872 16.2427 18.8943L9.34837 12L16.2427 5.10572C16.5356 4.81282 16.5356 4.33795 16.2427 4.04506C15.9498 3.75216 15.4749 3.75216 15.182 4.04506L7.93416 11.2929C7.54363 11.6834 7.54363 12.3166 7.93416 12.7071L15.182 19.955Z"
        fill="white"
      />
    </Svg>
  );
};

export default Icon;
